<a href="" v-on="$listeners" class="tt-o-gallery-item" :style="galleryItemStyles" :title="linkTitle"
    :aria-hidden="isHidden" :tabindex="tabIndex" aria-haspopup="dialog" rel="nofollow">
  <tt-media-thumb :altText="altText" :media="mediaItem" :size="mediaSize"></tt-media-thumb>
  <div v-if="showCaption" class="tt-o-gallery-item__caption">
    <span class="tt-o-gallery-item__caption-text">{{captionText}}<template v-if="truncatedText">&hellip;</template></span>
    <time class="tt-o-gallery-item__date">{{mediaItem.dateCreatedFormatted}}</time>
  </div>
</a>
